import script from "./SinglePodcast.vue?vue&type=script&setup=true&lang=js"
export * from "./SinglePodcast.vue?vue&type=script&setup=true&lang=js"

import "./SinglePodcast.vue?vue&type=style&index=0&id=f61d01d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f61d01d2"]])

export default __exports__